import { useEffect, useState } from "react";
import { Grid } from "antd";
//components
//actions
//selector
//function
//str
const { useBreakpoint } = Grid;

export const useResponsive = () => {
  // -------------------------- VAR ----------------------------
  const screen = useBreakpoint();
  // -------------------------- STATE --------------------------
  const [mobile, setMobile] = useState(false);
  const [tablet, setTablet] = useState(false);
  const [desktop, setDesktop] = useState(false);
  // -------------------------- REDUX -------------------------
  // -------------------------- FUNCTION ---------------------
  // -------------------------- EFFECT ------------------------
  // -------------------------- RENDER ------------------------
  useEffect(() => {
    if (screen?.xs) {
      setMobile(true);
      setTablet(false);
      setDesktop(false);
    }

    if (screen?.sm) {
      setMobile(false);
      setTablet(true);
      setDesktop(false);
    }

    if (screen?.md) {
      setMobile(false);
      setTablet(true);
      setDesktop(false);
    }

    if (screen?.lg) {
      setMobile(false);
      setTablet(false);
      setDesktop(true);
    }

    if (screen?.xl) {
      setMobile(false);
      setTablet(false);
      setDesktop(true);
    }

    if (screen?.xxl) {
      setMobile(false);
      setTablet(false);
      setDesktop(true);
    }
  }, [screen]);
  // -------------------------- MAIN ---------------------------
  return { mobile, tablet, desktop };
};
